import compliance from "../../assets/compiance.png";
import direitoCivil from "../../assets/direitoCivil.jpg";
import direitoConsumidor from "../../assets/direitoConsumidor.jpg";
import direitoTrabalho from "../../assets/direitoTrabalho2.png";
import previdence from "../../assets/previdenciario.png";
import work from "../../assets/work2.png";

const data = [
  {
    img: direitoTrabalho,
    title: "Direito do trabalho",
    desc: "Atuação preventiva e contenciosa com orientação segura para empresas e trabalhadores.",
    alt: "Imagem de direito do trabalho",
    label: "Trabalhista",
  },
  {
    img: compliance,
    title: "Compliance",
    desc: "Estruturação e acompanhamento de práticas de conformidade e redução de riscos.",
    alt: "Imagem de compliance",
    label: "Compliance",
  },
  {
    img: direitoCivil,
    title: "Direito Civil",
    desc: "Contratos, responsabilidade civil, família, sucessões, obrigações e indenizações.",
    alt: "Imagem de direito civil",
    label: "Cível",
  },
  {
    img: direitoConsumidor,
    title: "Direito do consumidor",
    desc: "Defesa de consumidores e fornecedores com foco em soluções preventivas e eficientes.",
    alt: "Imagem de direito do consumidor",
    label: "Consumidor",
  },
  {
    img: previdence,
    title: "Direito Previdenciário",
    desc: "Acompanhamento administrativo e judicial, revisões, pedidos e recursos de benefícios.",
    alt: "Imagem de direito previdenciário",
    label: "Previdenciário",
  },
  {
    img: work,
    title: "Demandas extrajudiciais",
    desc: "Pareceres, notificações, negociações e diligências com foco em resolução rápida.",
    alt: "Imagem de demandas extrajudiciais",
    label: "Extrajudicial",
  },
];

export default function Card() {
  return (
    <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
      {data.map((item) => (
        <article
          key={item.title}
          className="group overflow-hidden rounded-[1.75rem] border border-slate-200 bg-white shadow-[0_16px_40px_rgba(15,23,42,0.06)] transition duration-500 hover:-translate-y-1 hover:shadow-[0_24px_60px_rgba(15,23,42,0.12)]"
        >
          <div className="relative aspect-[4/3] overflow-hidden">
            <img
              className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
              src={item.img}
              alt={item.alt}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-950/75 via-slate-950/15 to-transparent" />
            <span className="absolute bottom-4 left-4 inline-flex min-w-[8.75rem] items-center justify-center rounded-full border border-white/70 bg-white/90 px-4 py-2 text-center text-[0.72rem] font-semibold uppercase tracking-[0.08em] text-slate-950 shadow-[0_8px_24px_rgba(15,23,42,0.18)]">
              {item.label}
            </span>
          </div>

          <div className="p-6">
            <h3 className="text-2xl font-semibold text-slate-950">
              {item.title}
            </h3>
            <p className="mt-3 text-sm leading-7 text-slate-600">
              {item.desc}
            </p>
          </div>
        </article>
      ))}
    </div>
  );
}
